import React, { useState } from "react";
import { useParams } from "react-router-dom";
import "./AdditionalInfo.css";

import user1 from "../../../Assets/Users/user1.jpeg";
import user2 from "../../../Assets/Users/user2.jpeg";

import { FaStar } from "react-icons/fa";
import Rating from "@mui/material/Rating";
import ProductDetail from "../../../Data/productdetail";

const AdditionalInfo = () => {
  const [activeTab, setActiveTab] = useState("aiTab1");
  const { productId } = useParams();

  // Find the current product based on URL parameter
  const currentProduct = ProductDetail.find(
    (product) => product.productID === parseInt(productId)
  ) || ProductDetail[0]; // Fallback to first product if not found

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Updated renderStars function to show both filled and unfilled stars
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <FaStar 
        key={index} 
        color={index < rating ? "#FEC78A" : "#E4E5E9"} 
        size={10} 
      />
    ));
  };

  return (
    <>
      <div className="productAdditionalInfo">
        <div className="productAdditonalInfoContainer">
          <div className="productAdditionalInfoTabs">
            <div className="aiTabs">
              <p
                onClick={() => handleTabClick("aiTab1")}
                className={activeTab === "aiTab1" ? "aiActive" : ""}
              >
                Description
              </p>
              <p
                onClick={() => handleTabClick("aiTab2")}
                className={activeTab === "aiTab2" ? "aiActive" : ""}
              >
                Additional Information
              </p>
              <p
                onClick={() => handleTabClick("aiTab4")}
                className={activeTab === "aiTab4" ? "aiActive" : ""}
              >
                Shipping
              </p>
              <p
                onClick={() => handleTabClick("aiTab3")}
                className={activeTab === "aiTab3" ? "aiActive" : ""}
              >
                Reviews ({currentProduct?.reviews?.length || 0})
              </p>
            </div>
          </div>
          <div className="productAdditionalInfoContent">
            {/* Tab1 */}
            {activeTab === "aiTab1" && (
              <div className="aiTabDescription">
                <div className="descriptionPara">
                  <h3>{currentProduct?.additionalInfo?.mainHeader}</h3>
                  <p>
                    {currentProduct?.additionalInfo?.mainDescription}
                  </p>
                </div>
                <div className="descriptionParaGrid">
                  <div className="descriptionPara">
                    <h3>Why choose product?</h3>
                    <p>
                      <ul>
                        {currentProduct?.additionalInfo?.whyChoose.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </p>
                  </div>
                  <div className="descriptionPara">
                    <h3>Shop with Confidence</h3>
                    <p>
                      <ol>
                        {currentProduct?.additionalInfo?.shopWithConfidence.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ol>
                    </p>
                  </div>
                </div>
                <div className="descriptionPara">
                  <h3>Lining</h3>
                  <p style={{ marginTop: "-10px" }}>
                    <li>{currentProduct?.additionalInfo?.lining}</li>
                  </p>
                </div>
              </div>
            )}

            {/* Tab2 */}
            {activeTab === "aiTab2" && (
              <div className="aiTabAdditionalInfo">
                <div className="additionalInfoContainer">
                  <h6>Weight</h6>
                  <p>{currentProduct?.additionalInfo?.weight}</p>
                </div>
                <div className="additionalInfoContainer">
                  <h6>Dimensions</h6>
                  <p>{currentProduct?.additionalInfo?.dimensions}</p>
                </div>
                <div className="additionalInfoContainer">
                  <h6>Size</h6>
                  <p>{currentProduct?.additionalInfo?.size.join(", ")}</p>
                </div>
                <div className="additionalInfoContainer">
                  <h6>Color</h6>
                  <p>{currentProduct?.additionalInfo?.color.join(", ")}</p>
                </div>
                <div className="additionalInfoContainer">
                  <h6>Storage</h6>
                  <p>{currentProduct?.additionalInfo?.storage}</p>
                </div>
              </div>
            )}

            {/* Tab3 */}
            {activeTab === "aiTab3" && (
              <div className="aiTabReview">
                <div className="aiTabReviewContainer">
                  <h3>Reviews</h3>
                  <div className="userReviews">
                    {currentProduct?.reviews?.map((review, index) => (
                      <div
                        key={index}
                        className="userReview"
                        style={
                          index !== currentProduct.reviews.length - 1
                            ? { borderBottom: "1px solid #e4e4e4" }
                            : {}
                        }
                      >
                        <div className="userReviewImg">
                          <img src={index % 2 === 0 ? user1 : user2} alt="" />
                        </div>
                        <div className="userReviewContent">
                          <div className="userReviewTopContent">
                            <div className="userNameRating">
                              <h6>{review.user}</h6>
                              <div className="userRating">
                                {renderStars(review.rating)}
                              </div>
                            </div>
                            <div className="userDate">
                              <p>{review.date}</p>
                            </div>
                          </div>
                          <div
                            className="userReviewBottomContent"
                            style={{ marginBottom: "30px" }}
                          >
                            <p>{review.comment}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="userNewReview">
                    <div className="userNewReviewMessage">
                      <h5>
                        Be the first to review "{currentProduct?.additionalInfo?.mainHeader}"
                      </h5>
                      <p>
                        Your email address will not be published. Required
                        fields are marked *
                      </p>
                    </div>
                    <div className="userNewReviewRating">
                      <label>Your rating *</label>
                      <Rating name="simple-controlled" size="small" />
                    </div>
                    <div className="userNewReviewForm">
                      <form>
                        <textarea
                          cols={30}
                          rows={8}
                          placeholder="Your Review"
                        />
                        <input
                          type="text"
                          placeholder="Name *"
                          required
                          className="userNewReviewFormInput"
                        />
                        <input
                          type="email"
                          placeholder="Email address *"
                          required
                          className="userNewReviewFormInput"
                        />
                        <div className="userNewReviewFormCheck">
                          <label>
                            <input type="checkbox" placeholder="Subject" />
                            Save my name, email, and website in this browser for
                            the next time I comment.
                          </label>
                        </div>
                        <button type="submit">Submit</button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Tab4 - Shipping Information */}
            {activeTab === "aiTab4" && (
              <div className="aiTabShipping">
                <div className="descriptionPara">
                  <h3>Standard Delivery</h3>
                  <p>
                    <strong>8-10 Business Days</strong><br />
                    This is the typical turnaround time for most items. Business days exclude 
                    weekends and holidays. So, if you order on a Friday, the 8-day clock 
                    wouldn't typically start until the following Monday.
                  </p>
                </div>
                <div className="descriptionPara">
                  <h3>Made-to-Order</h3>
                  <p>
                    Custom-crafted items produced exclusively after customer order, initiated 
                    with a 25% non-refundable deposit. By creating products specifically for 
                    each customer, we eliminate excess inventory and deliver precisely what 
                    you want—transforming individual requirements into tailored solutions 
                    that redefine personalized quality.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionalInfo;